
import { Injectable } from '@angular/core';

declare global {
  interface Window {
    gtag?: {
      (
        command: 'event',
        action: string,
        params?: Record<string, unknown>
      ): void;

      (
        command: 'get',
        targetId: string,
        fieldName: 'client_id',
        callback: (value: unknown) => void
      ): void;

      (
        command: 'get',
        targetId: string,
        fieldName: 'session_id',
        callback: (value: unknown) => void
      ): void;
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private enviarEvento(
    nome: string,
    parametros: Record<string, unknown> = {}
  ): void {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', nome, parametros);
    }
  }

  async obterIdentificadores(): Promise<{
    gaClientId?: string;
    gaSessionId?: number;
  }> {
    if (typeof window === 'undefined' || !window.gtag) {
      return {};
    }

    const obterCampo = (
      campo: 'client_id' | 'session_id'
    ): Promise<unknown> => {
      return new Promise(resolve => {
        const timeout = setTimeout(() => resolve(undefined), 1500);

        const finalizar = (valor: unknown) => {
          clearTimeout(timeout);
          resolve(valor);
        };

        try {
          if (campo === 'client_id') {
            window.gtag!(
              'get',
              'G-SGJLHJV89W',
              'client_id',
              finalizar
            );
          } else {
            window.gtag!(
              'get',
              'G-SGJLHJV89W',
              'session_id',
              finalizar
            );
          }
        } catch {
          finalizar(undefined);
        }
      });
    };

    const [clientId, sessionId] = await Promise.all([
      obterCampo('client_id'),
      obterCampo('session_id')
    ]);

    const gaClientId =
      typeof clientId === 'string' && clientId.trim()
        ? clientId
        : undefined;

    const sessionNumber = Number(sessionId);

    const gaSessionId =
      sessionId !== null &&
      sessionId !== undefined &&
      sessionId !== '' &&
      Number.isSafeInteger(sessionNumber) &&
      sessionNumber > 0
        ? sessionNumber
        : undefined;

    return {
      gaClientId,
      gaSessionId
    };
  }

  quartoVisualizado(nomeQuarto: string, quartoId: number): void {
    this.enviarEvento('view_item', {
      currency: 'BRL',
      items: [{
        item_id: String(quartoId),
        item_name: nomeQuarto
      }]
    });
  }

  datasSelecionadas(
    quartoId: number,
    checkIn: string,
    checkOut: string
  ): void {
    this.enviarEvento('selecionou_datas', {
      quarto_id: String(quartoId),
      check_in: checkIn,
      check_out: checkOut
    });
  }

  hospedesPreenchidos(
    quartoId: number,
    quantidadeHospedes: number
  ): void {
    this.enviarEvento('preencheu_hospedes', {
      quarto_id: String(quartoId),
      quantidade_hospedes: quantidadeHospedes
    });
  }

  registrarEvento(
    nome: string,
    parametros: Record<string, unknown> = {}
  ): void {
    this.enviarEvento(nome, parametros);
  }

  checkoutIniciado(
    quartoId: number,
    valor: number
  ): void {
    this.enviarEvento('begin_checkout', {
      currency: 'BRL',
      value: valor,
      items: [{
        item_id: String(quartoId)
      }]
    });
  }
}
